var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendarIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.62223 9.71108V8.11108H8.22223V9.71108H6.62223ZM3.42223 9.71108V8.11108H5.02223V9.71108H3.42223ZM9.82223 9.71108V8.11108H11.4222V9.71108H9.82223ZM6.62223 12.9111V11.3111H8.22223V12.9111H6.62223ZM3.42223 12.9111V11.3111H5.02223V12.9111H3.42223ZM9.82223 12.9111V11.3111H11.4222V12.9111H9.82223ZM0.222229 16.1111V1.31108H2.72223V0.111084H4.02223V1.31108H10.8222V0.111084H12.1222V1.31108H14.6222V16.1111H0.222229ZM1.42223 14.9111H13.4222V6.31108H1.42223V14.9111ZM1.42223 5.11108H13.4222V2.51108H1.42223V5.11108ZM1.42223 5.11108V2.51108V5.11108Z",
    fill: "#003845"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendarIcon.592e35af854a90b58c0f307e7785d852.svg";
export { ForwardRef as ReactComponent };